<template>
  <div v-if="loading" class="text-center mt-5 font-2xl text-muted">
    <i class="fal fa-spinner fa-spin" /> Audit Data Loading...
  </div>

  <div v-else class="animated fadeIn">
    <basic-heading title="Audit Trail" class="mb-3">
      <template #right-content>
        <header-button-group :button_config="button_config">
        </header-button-group>
      </template>
    </basic-heading>

    <permission-alert-gate :permissions="'read project'">
      <template #gated-content>
        <project-card :project="project" />

        <div>
          <h3>
            Change Log
            <b-button class="float-right" variant="success" :to="`/projects/${project_id}/audit-trail-history`">
              View History
            </b-button>
          </h3>
        </div>
        <AuditChangeLogTable
          :model="project"
        />

        <h3>Relations</h3>
        <AuditRelationTable
          :model="project"
        />
      </template>
    </permission-alert-gate>
  </div>
</template>

<script>
import ToastNotifications from '@/components/shared/mixins/ToastNotifications'
import PermissionAlertGate from "@/components/permission/PermissionAlertGate"
import ProjectCard from '@/components/lab/project/ProjectCard'
import AuditChangeLogTable from '@/components/shared/audit/AuditChangeLogTable'
import AuditRelationTable from '@/components/shared/audit/AuditRelationTable'
import BasicHeading from '@/components/shared/BasicHeading'
import HeaderButtonGroup from '@/components/shared/headerbuttons/HeaderButtonGroup'
import ProjectModel from '@/models/lab/ProjectModel'

export default {
  name: "ProjectAuditTrail",
  components: {
    PermissionAlertGate,
    ProjectCard,
    AuditChangeLogTable,
    AuditRelationTable,
    BasicHeading,
    HeaderButtonGroup
  },
  mixins: [ToastNotifications],
  data () {
    return {
      loading: true,
      project: null,
      project_id: this.$route.params.project_id || null
    };
  },
  computed: {
    button_config() {
      return {
        buttons: [
          {
            icon: "fa-eye",
            linkto: `/projects/${this.project_id}`,
            title: "View project",
            variant: "info",
          }
        ]
      }
    },
  },
  async created () {
    this.loading = true

    this.project = new ProjectModel({ id: this.project_id })

    const params = {}
    params.connection = ['auditCreatedBy', 'auditUpdatedBy']

    this.project.fetch({ params }).then(() => {
      this.loading = false
    })
  },
}
</script>
